<template>
   <div>
     <el-form :model="d_shop_from" ref="d_shop_from" label-width="100px">
        <el-form-item label="店铺名称" prop="shop_name" >
          <el-input v-model="d_shop_from.shop_name" placeholder="请输入店铺名称" :disabled="true"></el-input>
        </el-form-item>

        <el-form-item label="店主" prop="shop_owner" >
          <el-input v-model="d_shop_from.shop_owner" placeholder="请输入店铺名称" :disabled="true"></el-input>
        </el-form-item>

        <el-form-item label="店铺成员" prop="user_list" >
          <el-select v-model="d_shop_from.user_list" :disabled="true" clearable multiple placeholder="请选择店主" style="width:100%">
            <el-option
              v-for="item in d_shop_from.user_list"
              :key="item.id"
              :value="item.id"
              :label="item.username"
            > 
            </el-option>
          </el-select>
        </el-form-item>
    
        <el-form-item label="店铺地址" prop="shop_address" >
          <el-input v-model="d_shop_from.shop_address" :disabled="true" placeholder="请输入店铺地址"></el-input>
        </el-form-item>

        <el-form-item label="是否启用" prop="is_use">
          <el-switch v-model="d_shop_from.is_use" :disabled="true"></el-switch>
        </el-form-item>

        <el-form-item label="上传图片"> 
          <el-upload
            
            action= ''
            :disabled="true"
            :file-list="d_shop_from.img_list"
            list-type="picture-card">
            
          </el-upload>
        </el-form-item>

    </el-form>
   </div>
</template>

<script>
export default {
    name:'show_shop',
    props: ['dNowShowShopData'],

    data() {
        return {
            d_shop_from: this.dNowShowShopData,

        }
    },
    
    methods:{
      son_show_shop(){
        console.log(this.b_show_shop_dialog)
        console.log(this.b_show_shop_fullscreen)

        this.b_show_shop_dialog_son = false

        this.$emit('GetShowShopData', false, this.b_show_shop_fullscreen_son)

      },
      test_data(){
        console.log(this.dNowShowShopData)
      } 
    }
}
</script>

<style>

</style>
